export const emptyString = "";
export var ratingFilterEnum;
(function (ratingFilterEnum) {
    ratingFilterEnum[ratingFilterEnum["One"] = 1] = "One";
    ratingFilterEnum[ratingFilterEnum["Two"] = 2] = "Two";
    ratingFilterEnum[ratingFilterEnum["Three"] = 3] = "Three";
    ratingFilterEnum[ratingFilterEnum["Four"] = 4] = "Four";
    ratingFilterEnum[ratingFilterEnum["Five"] = 5] = "Five";
})(ratingFilterEnum || (ratingFilterEnum = {}));
export var modelFilterEnum;
(function (modelFilterEnum) {
    modelFilterEnum["Arteon"] = "Arteon";
    modelFilterEnum["Atlas"] = "Atlas";
    modelFilterEnum["AtlasCrossSport"] = "Atlas Cross Sport";
    modelFilterEnum["Beetle"] = "Beetle";
    modelFilterEnum["CC"] = "CC";
    modelFilterEnum["eGolf"] = "e-Golf";
    modelFilterEnum["Eos"] = "Eos";
    modelFilterEnum["Golf"] = "Golf";
    modelFilterEnum["GolfAlltrack"] = "Golf Alltrack";
    modelFilterEnum["GolfGTI"] = "Golf GTI";
    modelFilterEnum["GolfR"] = "Golf R";
    modelFilterEnum["GolfSportwagen"] = "Golf Sportwagen";
    modelFilterEnum["ID4"] = "ID.4";
    modelFilterEnum["Jetta"] = "Jetta";
    modelFilterEnum["JettaGLI"] = "Jetta GLI";
    modelFilterEnum["JettaSportwagen"] = "Jetta Sportwagen";
    modelFilterEnum["Passat"] = "Passat";
    modelFilterEnum["Taos"] = "Taos";
    modelFilterEnum["Tiguan"] = "Tiguan";
    modelFilterEnum["Touareg"] = "Touareg";
})(modelFilterEnum || (modelFilterEnum = {}));
export var surveyTypeFilterEnum;
(function (surveyTypeFilterEnum) {
    surveyTypeFilterEnum["Overall"] = "Overall";
    surveyTypeFilterEnum["Sales"] = "Sales";
    surveyTypeFilterEnum["Service"] = "Service";
})(surveyTypeFilterEnum || (surveyTypeFilterEnum = {}));
export var starTypeEnum;
(function (starTypeEnum) {
    starTypeEnum["Full"] = "Full";
    starTypeEnum["Half"] = "Half";
    starTypeEnum["Empty"] = "Empty";
})(starTypeEnum || (starTypeEnum = {}));
export function getDefaultFilter() {
    const defaultFilter = {};
    defaultFilter.surveyType = surveyTypeFilterEnum.Overall;
    defaultFilter.models = [];
    defaultFilter.ratings = [];
    return defaultFilter;
}
export const validationComment = "The reviews below are from verified owners of a Volkswagen vehicle within the last 7 model years " +
    "who received a survey invitation from Volkswagen of America after purchasing or servicing their vehicle " +
    "at an authorized Volkswagen dealer. The reviews are unique to each individual and should not be " +
    "generalized or interpreted as statements from Volkswagen.";
